import React, { Component } from "react";
import { EditorState } from "draft-js";
import { Button, Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import EditorComponent from "./EditorComponent";
import LoadingOverlay from "@/views/Components/LoadingOverlay";
import { handleError } from "@/util/errorHandler";
import swal from "sweetalert2";
import propertiesApi from "@/api/properties";
import { htmlToState, stateToHtml } from "./converters";

class Desktop extends Component {
  state = {
    isLoading: false,
    isTextChanged: false,
    editorState: EditorState.createEmpty(),
  };

  componentDidMount() {
    this.fetchCurrentState();
  }

  componentDidUpdate(
    prevProps,
    { editorState: prevEditorState, isLoading: wasLoading },
  ) {
    const { isTextChanged, editorState } = this.state;

    if (
      !wasLoading &&
      !isTextChanged &&
      prevEditorState._immutable.currentContent !==
        editorState._immutable.currentContent
    ) {
      this.setState({ isTextChanged: true });
    }
  }

  fetchCurrentState = async () => {
    try {
      this.setState({ isLoading: true });

      const { termConditionDesktop } = await propertiesApi.getProperties();

      if (termConditionDesktop) {
        this.setState({ editorState: htmlToState(termConditionDesktop) });
      }
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false, isTextChanged: false });
    }
  };

  onChangeEditorState = editorState => this.setState({ editorState });

  onAttemptToSaveChanges = async () => {
    const { value } = await swal({
      title: "Confirmation needed",
      text: "Do you want to change T&C for desktop?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Change",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (value) {
      this.saveChanges();
    }
  };

  saveChanges = async () => {
    try {
      this.setState({ isLoading: true });

      const text = stateToHtml(this.state.editorState);

      await propertiesApi.sendTermsAndConditionsDesktop(text);
      await swal(
        "Success",
        "T&C for desktop has been successfully changed",
        "success",
      );
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false, isTextChanged: false });
    }
  };

  render() {
    const { isLoading, isTextChanged, editorState } = this.state;

    return (
      <Card>
        <LoadingOverlay loading={isLoading} />
        <CardHeader>Edit Terms and Conditions for Desktop users</CardHeader>
        <CardBody>
          <EditorComponent
            editorState={editorState}
            onChangeEditorState={this.onChangeEditorState}
          />
        </CardBody>
        <CardFooter>
          <Button
            color="primary"
            data-cy="save"
            onClick={this.onAttemptToSaveChanges}
            style={{ width: 90 }}>
            Save
          </Button>
          <Button
            color="link"
            onClick={this.fetchCurrentState}
            disabled={!isTextChanged}>
            Discard changes
          </Button>
        </CardFooter>
      </Card>
    );
  }
}

export { Desktop };
